import { Box, Grid, Skeleton, Typography } from '@mui/material';
import { useAppSelector } from '../../../redux/hooks';

function OfficeDetailsSkeleton() {
  const { saveOfficedetailsLoading } = useAppSelector((state) => state.booking);

  return (
    <Grid
      display="flex"
      flexDirection="column"
      justifyContent="center"
      sx={{
        backgroundColor: '#fff',
        borderRadius: '10px',
        padding: '15px',
        marginTop: '24px',
        maxWidth: '430px',
        boxShadow: '0px 4px 40px 0px #ffddc840',
      }}
    >
      <Grid maxWidth={400}>
        <Typography variant="title1Bold" fontSize={14} ml={2}>
          <Skeleton width="50%" height={24} sx={{ borderRadius: 2, mb: 2 }} />
        </Typography>
        <Grid display="flex" flexDirection="row" alignItems="center" ml={1}>
          <Skeleton variant="rectangular" width={20} height={20} sx={{ borderRadius: 2 }} />
          <Skeleton variant="text" width="60%" height={24} sx={{ ml: 2 }} />
        </Grid>
        <Grid display="flex" flexDirection="row" alignItems="center" ml={1} mt={2}>
          <Skeleton variant="rectangular" width={20} height={20} sx={{ borderRadius: 2 }} />
          <Skeleton variant="text" width="60%" height={24} sx={{ ml: 2 }} />
        </Grid>
      </Grid>
      <Grid
        display="flex"
        flexDirection="column"
        gap={1.5}
        maxWidth={400}
        p={2}
        maxHeight={450}
        sx={{ overflowY: 'auto', mt: 3 }}
      >
        <Skeleton variant="rectangular" width="100%" height={100} sx={{ borderRadius: 4 }} />
        <Grid display="flex" flexDirection="row" alignItems="center" ml={-1} mt={2}>
          <Skeleton variant="rectangular" width={20} height={20} sx={{ borderRadius: 2 }} />
          <Skeleton variant="text" width="60%" height={24} sx={{ ml: 2 }} />
        </Grid>
        <Skeleton variant="rectangular" width="100%" height={100} sx={{ borderRadius: 4, mt: 2 }} />
        <Grid display="flex" flexDirection="row" alignItems="center" ml={-1} mt={2}>
          <Skeleton variant="rectangular" width={20} height={20} sx={{ borderRadius: 2 }} />
          <Skeleton variant="text" width="60%" height={24} sx={{ ml: 2 }} />
        </Grid>
      </Grid>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
        width="100%"
        pr={2}
        pb={2}
        pt={1}
      >
        <Skeleton
          variant="rectangular"
          width={120}
          height={40}
          sx={{ borderRadius: 4 }}
          animation={saveOfficedetailsLoading ? 'pulse' : 'wave'}
        />
      </Box>
    </Grid>
  );
}

export default OfficeDetailsSkeleton;
